import { DiscussionParticipantSummary } from "@cnx/common";
import api from "services/api";

class DiscussionParticipantService {
  static fetchDiscussionParticipantsById = async ({
    discussionId,
  }: {
    discussionId: string;
  }): Promise<DiscussionParticipantSummary[]> => {
    const { data } = await api.get<DiscussionParticipantSummary[]>(
      `/discussion-participant?discussionId=${discussionId}`
    );
    return data;
  };
  static removeDiscussionParticipant = async ({
    discussionId,
    userId,
  }: {
    discussionId: string;
    userId: string;
  }) => {
    return api.delete("/discussion-participant", {
      data: { discussionId, userId },
    });
  };
}

export default DiscussionParticipantService;
